import React, { useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import { signInUser, signInSSO, signOutUser } from "../../store/auth/authActions";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SubmitButton from "../../components/Forms/SubmitButton";
import SettingsTextInput from "../../components/Forms/SettingsTextInput";
import CustomButton from "../../components/Helpers/CustomButton";
import axios from "axios";
import { FRONTEND_VERSION } from "../../components/VersionBanner";

export default function LoginForm({ history }) {
    const [forgot, setForgot] = useState(false);
    const dispatch = useDispatch();
    // let location = useLocation();
    const { current_staff, authenticated } = useSelector((state) => state.auth);
    const ssoError = new URLSearchParams(window.location.search).get("sso_error");
    // ROMI-1924 — feature flag: hide the "Sign in with SSO" button unless explicitly
    // enabled, so SSO can be dark-launched. Set REACT_APP_SSO_ENABLED=true to show it.
    const ssoEnabled = process.env.REACT_APP_SSO_ENABLED === "true";

    const [isAdmin, setIsAdmin] = useState(false);
    const [adminSet, setAdminSet] = useState(false);

    useEffect(() => {
        if (current_staff?.id && authenticated === true && localStorage.getItem("token")) {
            // Check auth status before redirecting
            axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}check_auth`,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then((res) => {
                    if (current_staff?.restrict_views === 1) {
                        window.location.replace(process.env.REACT_APP_COLOUR === "UC" ? "/booking/mentions/0" : "/booking/mentions/0");
                    } else {
                        window.location.replace(process.env.REACT_APP_COLOUR === "UC" ? "/booking/newleads" : "/booking/unassigned");
                    }
                })
                .catch((error) => {
                    // If check_auth fails, clear the invalid session
                    localStorage.removeItem("token");
                    dispatch(signOutUser());
                });
        }
    }, [current_staff, authenticated]);

    if (adminSet === false) {
        setAdminSet(true);
        // Always show admin login form for all environments (UC, QL, QP)
        setIsAdmin(true);
    }

    return (
        <div className="min-h-screen flex">
            <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 xl:flex-none xl:px-24 ">
                <div className="mx-auto w-full max-w-sm xl:w-96">
                    <div>
                        <img
                            className="h-48 w-auto"
                            style={process.env.REACT_APP_CUSTOM_LOGO_LOGIN?.endsWith('.svg') ? { filter: 'brightness(0)' } : {}}
                            src={
                                process.env.REACT_APP_CUSTOM_LOGO_LOGIN
                                    ? (process.env.REACT_APP_CUSTOM_LOGO_LOGIN.startsWith('http')
                                        ? process.env.REACT_APP_CUSTOM_LOGO_LOGIN
                                        : `/images/${process.env.REACT_APP_CUSTOM_LOGO_LOGIN}`)
                                    : process.env.REACT_APP_COLOUR === "UC"
                                    ? "/images/logo_uc.svg"
                                    : process.env.REACT_APP_COLOUR === "QL"
                                    ? "/images/QL_Logo_final_colour.png"
                                    : "/images/logo-qholdings-v2.png"
                            }
                            alt="Quorom Properties"
                        />
                        {isAdmin === false && <h2 className="mt-6 text-2xl font-bold text-gray-900">Are you a student?</h2>}
                        {isAdmin === true && <h2 className="mt-6 text-2xl font-bold text-gray-900">Sign in to your admin account</h2>}
                    </div>

                    {ssoError && (
                        <div className="mt-4 rounded-md bg-red-50 border border-red-200 p-3 text-sm text-red-700">{ssoError}</div>
                    )}

                    {/* ROMI-1924 — single sign-on via Auth0 (preferred / migrated users).
                        Hidden unless REACT_APP_SSO_ENABLED is on, so it can be dark-launched. */}
                    {isAdmin === true && ssoEnabled && (
                        <button
                            type="button"
                            onClick={() => dispatch(signInSSO())}
                            className="bg-primary hover:bg-primary_hover focus:ring-primary relative text-white uppercase px-4 py-3 rounded-lg text-sm w-full text-center mt-8 transition duration-150 ease-in-ease-out hover:-translate-y-0.5"
                        >
                            Sign in with SSO
                        </button>
                    )}
                    {isAdmin === true && ssoEnabled && (
                        <div className="mt-4 text-center text-xs text-gray-400">or sign in with your password (if you haven't moved to SSO yet)</div>
                    )}

                    <div className="mt-8">
                        <div className="mt-6">
                            {isAdmin === false && (
                                <>
                                    <Link to={"/"}>
                                        <button
                                            type="button"
                                            className="bg-primary hover:bg-primary_hover focus:ring-primary relative text-white uppercase items-center px-4 py-2 rounded-lg text-sm focus:z-10 focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 w-full text-center"
                                        >
                                            {" "}
                                            Yes{" "}
                                        </button>
                                    </Link>

                                    <button
                                        type="button"
                                        className="bg-primary hover:bg-primary_hover focus:ring-primary relative text-white uppercase items-center px-4 py-2 rounded-lg text-sm focus:z-10 focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 w-full text-center mt-5"
                                        onClick={() => setIsAdmin(true)}
                                    >
                                        {" "}
                                        No{" "}
                                    </button>
                                </>
                            )}

                            {isAdmin === true && (
                                <Formik
                                    hidden={forgot === true ? true : false}
                                    initialValues={{
                                        email: "",
                                        password: "",
                                    }}
                                    validate={(values) => {
                                        const errors = {};
                                        if (!values.email) {
                                            errors.email = "Required";
                                        }
                                        if (forgot === false) {
                                            if (!values.password) {
                                                errors.password = "Required";
                                            }
                                        }
                                        return errors;
                                    }}
                                    onSubmit={async (values, { setSubmitting, setErrors }) => {
                                        if (forgot === true) {
                                            console.log("password reset");
                                        } else {
                                            try {
                                                await dispatch(
                                                    signInUser({
                                                        email: values.email,
                                                        password: values.password,
                                                    })
                                                ).then((res) => {
                                                    if (res === "ok") {
                                                        // ROMI-1924 — legacy login established a cookie session; land on the app.
                                                        window.location.replace("/booking/unassigned");
                                                    } else {
                                                        setErrors({
                                                            auth: res,
                                                        });
                                                    }
                                                });
                                            } catch (error) {
                                                console.log("error.response", error.respones.data.message);

                                                if (error.response.data.message) {
                                                    setErrors({
                                                        auth: error.response.data.message,
                                                    });
                                                } else {
                                                    setErrors({
                                                        auth: "Something went wrong",
                                                    });
                                                }
                                            }
                                        }
                                    }}
                                >
                                    {({ values, errors, setFieldValue, handleSubmit, isValid, isSubmitting, dirty }) => (
                                        <Form onSubmit={handleSubmit}>
                                            <Field name="email" as={SettingsTextInput} type="email" label="Email Address" />
                                            <Field name="password" label="Password" as={SettingsTextInput} type="password" hidden={forgot === true} />

                                            {errors.auth ? <p className="my-4 text-medium text-red-500">{errors.auth}</p> : ""}

                                            <div className="py-8 flex space-x-2">
                                                <SubmitButton disabled={!isValid || isSubmitting || !dirty} isSubmitting={isSubmitting} type="submit" name="submit" text="Sign in" />
                                                <Link to={"/forget-password"}>
                                                    <CustomButton text="Forgotten your Password?" />
                                                </Link>
                                            </div>
                                            <p className="text-sm uppercase">V {FRONTEND_VERSION}</p>
                                        </Form>
                                    )}
                                </Formik>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="hidden xl:block relative w-0 flex-1">
                <img className="absolute inset-0 h-full w-full object-cover" src={process.env.REACT_APP_COLOUR === "UC" ? "/images/login_bg_uc.jpg" : "/images/login_bg.jpg"} alt="Login Background" />
            </div>
        </div>
    );
}
